import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import { setPortal } from 'modules/portal';
import { makeRowColumn, getHeadObj, dataConverter } from 'lib/commonLib';
import { mediaStatistics, mediaStatisticsDetail } from 'lib/api/media';
import { noBannerPayType } from 'lib/api/media';

import IconAreaWrap from 'components/molecules/MbTable/IconAreaWrap';
import VariousCell from 'components/molecules/MbTable/VariousCell';
import InfoTitleArea from 'components/molecules/MbTable/InfoTitleArea';
import FilterCollection from 'components/organisms/FilterCollection';
import NewTableContainer from 'components/molecules/NewTable';
import NewFilterWrap from 'components/molecules/NewFilterWrap';
import NewCommonFilter from 'components/organisms/NewCommonFilter';
import queryString from 'query-string';

// let defaultCheckInfo = [];
// defaultCheckInfo['all'] = {
//   value: 'Y',
//   checked: true,
// };
// defaultCheckInfo['01'] = {
//   value: 'Y',
//   checked: true,
// };
// defaultCheckInfo['02'] = {
//   value: 'Y',
//   checked: true,
// };
// defaultCheckInfo['03'] = {
//   value: 'Y',
//   checked: true,
// };
// defaultCheckInfo['04'] = {
//   value: 'Y',
//   checked: true,
// };
// defaultCheckInfo['05'] = {
//   value: 'Y',
//   checked: true,
// };

const Statistics = ({ location }) => {
  // 통계보고서 - 일자별통계 - 일자별통계: sDate, eDate, advrtsPrdtCode, advrtsTpCode, pltfomTpCode, itlTpCode
  // 통계보고서 - 일자별통계 - 총노출통계: sDate, eDate, advrtsPrdtCode, advrtsTpCode, pltfomTpCode, itlTpCode
  let initParams = {
    sort: 'desc',
    order: 'ADVRTS_AMT',
    itlTpCode: 'all',
    pltfomTpCode: 'all',
    sDate: moment().format('YYYYMM01'),
    eDate: moment().format('YYYYMMDD'),
  };
  const convertKeys = [
    'sDate',
    'eDate',
    'adverId',
    'advrtsPrdtCode',
    'advrtsTpCode',
    'pltfomTpCode',
    'itlTpCode',
  ];
  const newInitParams = dataConverter(
    queryString.parse(location.search),
    convertKeys
  );
  initParams = {
    ...initParams,
    ...newInitParams,
  };

  const [filterList, setFilterList] = useState({
    payType: [],
  });
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { portal } = useSelector(({ portal }) => ({
    portal: portal,
  }));
  const [initialization, setInitialization] = useState(false);
  const [params, setParams] = useState(initParams);

  // const initLoading = {
  //   table: true,
  // };
  // const [loading, setLoading] = useState(initLoading);
  const handlePortalUrl = (url) => {
    let newPortal = portal.portal;
    let popIndex = newPortal.length;
    newPortal[popIndex] = { url: url, cnt: popIndex };
    dispatch(setPortal(newPortal));
  };

  useEffect(() => {
    getFilterList();
    // eslint-disable-next-line
  }, []);

  /**
   * 필터 초기화 후 값을 바꿈
   */
  useEffect(() => {
    if (initialization === true) {
      setInitialization(false);
    } // eslint-disable-next-line
  }, [initialization]);

  /**
   * 정산방식 getData
   */
  const getFilterList = () => {
    noBannerPayType()
      .then((response) => {
        const { data } = response.data;
        let newFilterList = {
          payType: data,
        };
        setFilterList(newFilterList);
      })
      .catch((error) => {});
  };

  // header 및 body 컬럼 커스텀
  const customized = {
    MEDIA_NAME: {
      makeHead: (headsMap) => {
        return `${getHeadObj(headsMap, 'MEDIA_NAME').label}`;
      },
      makeBody: (rowObj, headsMap) => {
        const mediaName = getHeadObj(headsMap, 'MEDIA_NAME');
        const showWindowUrl =
          '/report/daily/par?sDate=' +
          params.sDate +
          '&eDate=' +
          params.eDate +
          '&mediaId=' +
          rowObj['MEDIA_ID'] +
          '&uri=/report/daily/par&isPop=1&popGroup=media';
        let resultComponent;
        resultComponent = (
          <>
            {rowObj['PLTFOM_TP_CODE'] === undefined ? (
              <IconAreaWrap
                text={makeRowColumn(
                  rowObj['MEDIA_NAME'],
                  mediaName.type,
                  mediaName.format
                )}
                icon={rowObj['MEDIA_NAME'] !== 'total' && 'faExternalLink'}
                toolTipTitle={t('해당 매체의 일자별통계')}
                onClick={(e) => handlePortalUrl(showWindowUrl)}
              />
            ) : (
              <>
                {makeRowColumn(rowObj['PLTFOM_TP_CODE']) === '01' ? (
                  <>{t('웹')}</>
                ) : (
                  makeRowColumn(rowObj['PLTFOM_TP_CODE']) === '02' && (
                    <>{t('모바일')}</>
                  )
                )}
              </>
            )}
          </>
        );
        return resultComponent;
      },
    },

    PAR_EPRS_CNT: {
      makeHead: (headsMap) => {
        return (
          <>
            {getHeadObj(headsMap, 'PAR_EPRS_CNT').label}
            <br />({getHeadObj(headsMap, 'CHRG_PAR_EPRS_CNT').label})
          </>
        );
      },
      makeBody: (rowObj, headsMap) => {
        const parEprsCnt = getHeadObj(headsMap, 'PAR_EPRS_CNT');
        const chrgParEprsCnt = getHeadObj(headsMap, 'CHRG_PAR_EPRS_CNT');
        const chrgRate = getHeadObj(headsMap, 'CHRG_RATE');
        return (
          <>
            {makeRowColumn(
              rowObj['PAR_EPRS_CNT'],
              parEprsCnt.type,
              parEprsCnt.format
            )}
            <br />
            <span className="gray">
              {makeRowColumn(
                rowObj['CHRG_PAR_EPRS_CNT'],
                chrgParEprsCnt.type,
                chrgParEprsCnt.format
              )}
            </span>
            <span className="black">
              (
              {makeRowColumn(
                rowObj['CHRG_RATE'],
                chrgRate.type,
                chrgRate.format
              )}
              )
            </span>
          </>
        );
      },
    },
    CHRG_PAR_EPRS_CNT: {
      merged: true,
    },
    CHRG_RATE: {
      merged: true,
    },
    // 클릭수
    CLICK_CNT: {
      makeHead: (headsMap) => {
        return `${getHeadObj(headsMap, 'CLICK_CNT').label}`;
      },
      makeBody: (rowObj, headsMap) => {
        const statsClickCnt = getHeadObj(headsMap, 'CLICK_CNT');
        const showWindowUrl =
          '/report/adver/statistics?sDate=' +
          params.sDate +
          '&eDate=' +
          params.eDate +
          '&mediaId=' +
          rowObj.MEDIA_ID +
          '&uri=/report/adver/statistics&isPop=1&popGroup=adver';
        // console.log(rowObj['MEDIA_NAME'] === 'total');
        let resultComponent = (
          <IconAreaWrap
            text={makeRowColumn(
              rowObj['CLICK_CNT'],
              statsClickCnt.type,
              statsClickCnt.format
            )}
            icon={rowObj['MEDIA_NAME'] !== 'total' && 'faExternalLink'}
            toolTipTitle={t('해당 매체의 광고주별 통계')}
            onClick={(e) => handlePortalUrl(showWindowUrl)}
          />
        );
        return resultComponent;
      },
    },
    IVD_CNT: {
      merged: true,
    },
    IVD_RATE: {
      merged: true,
    },

    ORDER_CNT: {
      makeHead: (headsMap) => {
        return `${getHeadObj(headsMap, 'ORDER_CNT').label}`;
      },
      makeBody: (rowObj, headsMap) => {
        const orderCnt = getHeadObj(headsMap, 'ORDER_CNT');
        const showWindowUrl =
          '/report/conversion/state_list?sDate=' +
          params.sDate +
          '&eDate=' +
          params.eDate +
          '&mediaId=' +
          rowObj.MEDIA_ID +
          '&uri=/report/conversion/state_list&isPop=1';
        let resultComponent;
        if (rowObj.isChild) {
          resultComponent = (
            <>
              {makeRowColumn(
                rowObj['ORDER_CNT'],
                orderCnt.type,
                orderCnt.format
              )}
            </>
          );
        } else {
          resultComponent = (
            <IconAreaWrap
              text={makeRowColumn(
                rowObj['ORDER_CNT'],
                orderCnt.type,
                orderCnt.format
              )}
              icon={rowObj['MEDIA_NAME'] !== 'total' && 'faExternalLink'}
              toolTipTitle={t('해당 날짜의 컨버전 리스트')}
              onClick={(e) => handlePortalUrl(showWindowUrl)}
            />
          );
        }
        return resultComponent;
      },
    },

    ADVRTS_AMT: {
      makeHead: (headsMap) => {
        return (
          <>
            {getHeadObj(headsMap, 'ADVRTS_AMT').label}
            <br />({getHeadObj(headsMap, 'TRGT_ADVRTS_AMT').label})
          </>
        );
      },
      makeBody: (rowObj, headsMap) => {
        const advrtsAmt = getHeadObj(headsMap, 'ADVRTS_AMT');
        const trgtAdvrtsAmt = getHeadObj(headsMap, 'TRGT_ADVRTS_AMT');
        const mcPoint = getHeadObj(headsMap, 'MC_POINT');
        const mcPointRate = getHeadObj(headsMap, 'MC_POINT_RATE');
        return (
          <>
            {makeRowColumn(
              rowObj['ADVRTS_AMT'],
              advrtsAmt.type,
              advrtsAmt.format
            )}
            <span className="black">
              (
              {makeRowColumn(
                rowObj['TRGT_ADVRTS_AMT'],
                trgtAdvrtsAmt.type,
                trgtAdvrtsAmt.format
              )}
              )
            </span>
            <br />
            <span className="gray">
              {makeRowColumn(rowObj['MC_POINT'], mcPoint.type, mcPoint.format)}
            </span>
            <span className="black">
              (
              {makeRowColumn(
                rowObj['MC_POINT_RATE'],
                mcPointRate.type,
                mcPointRate.format
              )}
              )
            </span>
          </>
        );
      },
    },
    TRGT_ADVRTS_AMT: {
      merged: true,
    },
    MC_POINT: {
      merged: true,
    },
    MC_POINT_RATE: {
      merged: true,
    },
    MOB_SESSION_ROAS: {
      makeHead: (headsMap) => {
        return {
          content: (
            <>
              <InfoTitleArea
                title={
                  getHeadObj(headsMap, 'MOB_SESSION_ROAS').label +
                  '(' +
                  t('쇼핑') +
                  ')'
                }
                tooltipType={'MOB_SESSION_ROAS'}
                iconType="fainfoCircle"
              />
            </>
          ),
          orderFlag: true,
        };
      },
      makeBody: (rowObj, headsMap) => {
        const mobSessionRoas = getHeadObj(headsMap, 'MOB_SESSION_ROAS');
        const trgtMobSessionRoas = getHeadObj(
          headsMap,
          'TRGT_MOB_SESSION_ROAS'
        );
        const mobSessionOrderAmt = getHeadObj(
          headsMap,
          'MOB_SESSION_ORDER_AMT'
        );
        return (
          <VariousCell
            type="TRGT"
            item1={makeRowColumn(
              rowObj['MOB_SESSION_ROAS'],
              mobSessionRoas.type,
              mobSessionRoas.format
            )}
            item2={makeRowColumn(
              rowObj['TRGT_MOB_SESSION_ROAS'],
              trgtMobSessionRoas.type,
              trgtMobSessionRoas.format
            )}
            item3={makeRowColumn(
              rowObj['MOB_SESSION_ORDER_AMT'],
              mobSessionOrderAmt.type,
              mobSessionOrderAmt.format
            )}
          />
        );
      },
    },
    TRGT_MOB_SESSION_ROAS: {
      merged: true,
    },
    MOB_SESSION_ORDER_AMT: {
      merged: true,
    },
    SESSION_ROAS: {
      makeHead: (headsMap) => {
        return {
          content: (
            <>
              <InfoTitleArea
                title={
                  getHeadObj(headsMap, 'SESSION_ORDER_AMT').label +
                  '(' +
                  t('쇼핑') +
                  ')'
                }
                tooltipType={'SESSION_ROAS'}
                iconType="fainfoCircle"
              />
            </>
          ),
          orderFlag: true,
        };
      },
      makeBody: (rowObj, headsMap) => {
        const sessionRoas = getHeadObj(headsMap, 'SESSION_ROAS');
        const trgtSessionRoas = getHeadObj(headsMap, 'TRGT_SESSION_ROAS');
        const sessionOrderAmt = getHeadObj(headsMap, 'SESSION_ORDER_AMT');
        return (
          <VariousCell
            type="TRGT"
            item1={makeRowColumn(
              rowObj['SESSION_ROAS'],
              sessionRoas.type,
              sessionRoas.format
            )}
            item2={makeRowColumn(
              rowObj['TRGT_SESSION_ROAS'],
              trgtSessionRoas.type,
              trgtSessionRoas.format
            )}
            item3={makeRowColumn(
              rowObj['SESSION_ORDER_AMT'],
              sessionOrderAmt.type,
              sessionOrderAmt.format
            )}
          />
        );
      },
    },
    TRGT_SESSION_ROAS: {
      merged: true,
    },
    SESSION_ORDER_AMT: {
      merged: true,
    },
    DIRECT_ROAS: {
      makeHead: (headsMap) => {
        return (
          <>
            <InfoTitleArea
              title={
                getHeadObj(headsMap, 'DIRECT_ORDER_AMT').label +
                '(' +
                t('쇼핑') +
                ')'
              }
              tooltipType={'DIRECT_ROAS'}
              iconType="fainfoCircle"
            />
          </>
        );
      },
      makeBody: (rowObj, headsMap) => {
        const directRoas = getHeadObj(headsMap, 'DIRECT_ROAS');
        const trgtDirectRoas = getHeadObj(headsMap, 'TRGT_DIRECT_ROAS');
        const directOrderAmt = getHeadObj(headsMap, 'DIRECT_ORDER_AMT');
        return (
          <VariousCell
            type="TRGT"
            item1={makeRowColumn(
              rowObj['DIRECT_ROAS'],
              directRoas.type,
              directRoas.format
            )}
            item2={makeRowColumn(
              rowObj['TRGT_DIRECT_ROAS'],
              trgtDirectRoas.type,
              trgtDirectRoas.format
            )}
            item3={makeRowColumn(
              rowObj['DIRECT_ORDER_AMT'],
              directOrderAmt.type,
              directOrderAmt.format
            )}
          />
        );
      },
    },
    TRGT_DIRECT_ROAS: {
      merged: true,
    },
    DIRECT_ORDER_AMT: {
      merged: true,
    },
    ROAS: {
      makeHead: (headsMap) => {
        return (
          <>
            <InfoTitleArea
              title={
                getHeadObj(headsMap, 'ORDER_AMT').label + '(' + t('쇼핑') + ')'
              }
              tooltipType={'ROAS'}
              iconType="fainfoCircle"
            />
          </>
        );
      },
      makeBody: (rowObj, headsMap) => {
        const roas = getHeadObj(headsMap, 'ROAS');
        const trgtRoas = getHeadObj(headsMap, 'TRGT_ROAS');
        const orderAmt = getHeadObj(headsMap, 'ORDER_AMT');
        return (
          <VariousCell
            type="TRGT"
            item1={makeRowColumn(rowObj['ROAS'], roas.type, roas.format)}
            item2={makeRowColumn(
              rowObj['TRGT_ROAS'],
              trgtRoas.type,
              trgtRoas.format
            )}
            item3={makeRowColumn(
              rowObj['ORDER_AMT'],
              orderAmt.type,
              orderAmt.format
            )}
          />
        );
      },
    },
    TRGT_ROAS: {
      merged: true,
    },
    ORDER_AMT: {
      merged: true,
    },
    ECPM: {
      makeHead: (headsMap) => {
        return (
          <>
            <InfoTitleArea
              title={getHeadObj(headsMap, 'ECPM').label + '(' + t('쇼핑') + ')'}
              tooltipType={'ECPM'}
              iconType="fainfoCircle"
            />
          </>
        );
      },
      makeBody: (rowObj, headsMap) => {
        const ecpm = getHeadObj(headsMap, 'ECPM');
        const trgtEcpm = getHeadObj(headsMap, 'TRGT_ECPM');
        return (
          <VariousCell
            type="TRGT"
            item1={makeRowColumn(rowObj['ECPM'], ecpm.type, ecpm.format)}
            item2={makeRowColumn(
              rowObj['TRGT_ECPM'],
              trgtEcpm.type,
              trgtEcpm.format
            )}
          />
        );
      },
    },
    TRGT_ECPM: {
      merged: true,
    },
  };

  /**
   * 필터 초기화
   */
  const handleOnReset = () => {
    setInitialization(true);
    setParams(initParams);
  };

  /**
   * 테이블 클릭 후 세부정보 받아올때 보낼 param setting 해주는 함수
   * @param {json} data 테이블 로우 데이터
   */
  const makeSubParam = (row) => {
    return {
      mediaId: row.MEDIA_ID,
    };
  };

  const getParam = (newParams) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setParams(newParams);
    }
  };

  // const callBack = (type, data) => {
  // console.log('callBack => ', type, data);
  // };

  return (
    <>
      <NewFilterWrap handleOnReset={handleOnReset}>
        <NewCommonFilter
          initialization={initialization}
          params={params}
          getParam={getParam}
          pltfomTpCodeDetailFilter={['03', '04']}
        />
        <FilterCollection
          label={t('정산방식')}
          name="payType"
          type="checkbox"
          labelKey="CODE_VAL"
          valueKey="CODE_ID"
          list={filterList.payType}
          params={params}
          callBack={getParam}
          useSubmit
          submitTitle={t('확인')}
        />
      </NewFilterWrap>
      <NewTableContainer
        params={params}
        getParam={getParam}
        dataReqPromise={mediaStatistics}
        dataDetailReqPromise={mediaStatisticsDetail}
        makeSubParam={makeSubParam}
        customized={customized}
        expandTable
        // callBack={callBack}
        useTotal={false}
      />
    </>
  );
};

export default withRouter(Statistics);
